import { AggWeatherSchema } from 'app/agriculture/hooks/useAggregateChartData/types/AggWeatherSchema';

export function parseDailyRainfallQueryData(data: unknown) {
    const result = AggWeatherSchema.array().optional().parse(data);

    if (result == null || result.length === 0) return;

    return result[0]?.rainfallSum ?? undefined;
}
